export default "__VITE_ASSET__4a6d3119__"